<template>
  <div
    style="overflow-y: hidden; overflow-x: hidden"
    class="wa-chat"
    @drop.prevent="addFile"
    @dragover.prevent
  >
    <v-toolbar color="grey lighten-2" elevation="1" dense>
      <v-list-item-avatar
        color="grey"
        @click="expand = !expand"
        style="cursor: pointer"
        class="userimage"
        small
      >
        <v-img
          v-if="atendimento"
          :src="`${ip}/gravacoes/clientes/${atendimento.idCliente}.jpg`"
        ></v-img>
      </v-list-item-avatar>
      <v-list-item-content class="ml-0">
        <v-list-item-title>{{ call.numero }}</v-list-item-title>

        <v-list-item-subtitle class="font-weight-light text--secondary">{{
          formataData(call.dataIni)
        }}</v-list-item-subtitle>
      </v-list-item-content>
      <!-- <span class="green--text ml-2">00:45:12</span> -->
      <v-spacer></v-spacer>
      <a
        :href="urlIntegracao"
        target="_blank"
        class="ml-5"
        v-if="config.urlIntegracao"
      >
        <v-icon color="primary">mdi-open-in-new</v-icon>
      </a>
      <!-- <v-icon class="ml-5" :color="getColorByStatus()">{{
        getIconByStatus()
      }}</v-icon> -->
      <span class="ml-2 d-md-none d-lg-flex d-xl-flex d-sm-none">{{
        getStatus(call.status)
      }}</span>
      <v-icon @click="criarConferencia()">mdi-account-group</v-icon>
      <v-icon @click="modalAgendar = true">mdi-calendar-clock</v-icon>
      <v-icon class="ml-5">mdi-database</v-icon>
      <span class="ml-2">{{ call.fila }}</span>

      <v-icon class="ml-5">mdi-pound</v-icon>
      <span class="ml-2">{{
        atendimento ? atendimento.id : mostrarDados()["Unique-Id"]
      }}</span>

      <v-icon
        class="ml-5"
        v-show="
          !atendimento || (atendimento && atendimento.status !== 'Encerrado')
        "
        >mdi-alarm</v-icon
      >
      <relogio
        :datainicial="new Date(call.dataini)"
        v-show="
          !atendimento || (atendimento && atendimento.status !== 'Encerrado')
        "
      ></relogio>
    </v-toolbar>
    <!-- #endregion MENU-->
    <!-- #region MESSAGES-->
    <v-main class="mt-1" style="display: flex; flex-direction: column">
      <div
        class="wa-chat"
        style="
          flex: 1;
          height: calc(100vh - 160px);
          flex-shrink: 5;
          overflow-y: scroll;
        "
      >
        <v-container>
          <Conferencia :ligacao="call" v-if="ligacao.conference" />
          <div v-else>
            <v-alert
              v-model="expand"
              class="mx-auto"
              elevation="2"
              dismissible
              colored-border
              border="top"
              color="#FFAB40"
              style="width: 90%"
              icon="mdi-clipboard-account"
              v-if="call"
            >
              <template v-for="(value, key, index) in mostrarDados()">
                <v-text-field
                  v-if="
                    key !== `CamposAdicionais` && key !== `NumerosAdicionais`
                  "
                  :key="index"
                  style="width: 60%"
                  dense
                  :label="key"
                  :value="value"
                  readonly
                ></v-text-field>
              </template>
              <div v-if="cliente">
                <template v-for="(value, key, index) in cliente">
                  <template v-if="key === `CamposAdicionais`">
                    <v-text-field
                      v-for="campo in value"
                      :key="campo.id"
                      style="width: 60%"
                      dense
                      :label="campo.nome"
                      :value="campo.valor"
                      readonly
                    ></v-text-field>
                  </template>
                  <template v-else-if="key === `NumerosAdicionais`">
                    <v-text-field
                      v-for="numero in value"
                      :key="numero.id"
                      style="width: 60%"
                      dense
                      :label="numero.nome"
                      :value="numero.numero"
                      readonly
                    ></v-text-field>
                  </template>
                  <template v-else>
                    <v-text-field
                      :key="index"
                      v-if="
                        key !== `CamposAdicionais` &&
                        key !== `NumerosAdicionais`
                      "
                      style="width: 60%"
                      dense
                      :label="key"
                      :value="value"
                      readonly
                    ></v-text-field>
                  </template>
                </template>
              </div>

              <h2 v-if="Object.keys(mostrarDados()).length == 0 && !cliente">
                {{ t(`dadosIndisponiveis`) }}
              </h2>
            </v-alert>
            <v-alert
              v-for="msg in messages"
              :key="msg.id"
              :data="msg"
              width="90%"
              class="mx-auto"
              elevation="2"
              dismissible
              colored-border
              border="top"
              type="info"
            >
              {{ msg.texto }} -
              <span
                style="font-style: italic; font-size: 0.8em; font-weight: bold"
                >{{ formataHora(msg.dataHora) }}</span
              >
            </v-alert>
          </div>
        </v-container>
      </div>
      <v-footer
        color="grey lighten-2"
        elevation="0"
        padless
        style="min-height: 48px"
      >
        <v-card-actions
          class="mx-auto"
          v-show="
            !atendimento || (atendimento && atendimento.status !== 'Encerrado')
          "
        >
          <v-spacer></v-spacer>
          <v-btn
            v-if="config.webrtc && call"
            text
            class="mr-2"
            color="indigo"
            @click="confirmTransfer(call.callid)"
          >
            <v-icon>mdi-phone-forward</v-icon>
            <span class="ml-2">{{ t("transferir") }}</span>
          </v-btn>
          <!-- <v-btn @click="conference()">Conferencia</v-btn> -->
          <v-btn
            text
            color="warning"
            class="mr-2"
            @click="modalClassificacao = true"
          >
            <v-icon>mdi-star</v-icon>
            <span class="ml-2">{{ t("classificar") }}</span>
          </v-btn>
          <!-- <v-btn icon dark class="mr-2" color="green">
            <v-icon>mdi-phone</v-icon>
          </v-btn>-->
          <v-btn
            v-if="config.webrtc && call"
            text
            class="mr-2"
            @click="toggleMic(call)"
          >
            <v-icon v-if="call.mic">mdi-microphone</v-icon>
            <v-icon v-else>mdi-microphone-off</v-icon>
            <span v-if="call.mic" class="ml-2">{{ t("desativar") }}</span>
            <span v-else class="ml-2">{{ t("ativar") }}</span>
          </v-btn>

          <v-btn
            v-if="config.webrtc && call"
            text
            class="mr-2"
            color="success"
            @click="togglePause(call)"
          >
            <v-icon v-if="call.pause">mdi-play</v-icon>
            <v-icon v-else>mdi-pause</v-icon>
            <span v-if="call.pause" class="ml-2">{{ t("removerPausa") }}</span>
            <span v-else class="ml-2">{{ t("pausar") }}</span>
          </v-btn>
          <v-btn
            text
            dark
            color="red"
            @click="desligar(call.callid)"
            class="mr-2"
          >
            <v-icon>mdi-phone-hangup</v-icon>
            <span class="ml-2">{{ t("desligar") }}</span>
          </v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-footer>
    </v-main>

    <v-dialog v-model="poptransfer">
      <v-card>
        <v-card-title class="headline grey lighten-2" primary-title>{{
          t("transferencia")
        }}</v-card-title>
        <v-card-text>
          <v-text-field
            v-model="consultaNum"
            label="Consultar agente"
            v-on:keyup.enter="discar()"
            required
            :rules="[(v) => !!v || t('fraseCampoObrigatorio')]"
          >
            <v-btn slot="append" small color="green" dark @click="discar()">
              <v-icon dark>mdi-phone</v-icon>
            </v-btn>
          </v-text-field>

          <template v-if="calls.length > 1">
            <h4>Selecione uma ligação ou informe o destino</h4>
            <v-simple-table>
              <template v-slot:default>
                <tbody class="grey lighten-4">
                  <tr
                    v-for="ligacao in filterCalls(call.callid)"
                    :key="ligacao.callid"
                  >
                    <td>{{ ligacao.numero }}</td>
                    <td>{{ ligacao.nome }}</td>
                    <td class="text-end">
                      <v-btn
                        icon
                        dark
                        color="red"
                        @click="
                          desligar(ligacao.callid);
                          removerPausaAutomatico();
                        "
                      >
                        <v-icon>mdi-phone-hangup</v-icon>
                      </v-btn>
                      <v-btn
                        icon
                        class="mr-2"
                        @click="AttendedTransfer(ligacao.callid)"
                      >
                        <v-icon>mdi-phone-forward</v-icon>
                      </v-btn>
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </template>
          <v-form v-model="transfer.valid" @submit.prevent="transferir">
            <v-text-field
              v-model="transfer.destino"
              label="Destino"
              required
              autofocus
              :rules="[(v) => !!v || t('fraseCampoObrigatorio')]"
            ></v-text-field>
          </v-form>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red" text @click="poptransfer = false">Cancelar</v-btn>
          <v-btn
            color="primary"
            text
            @click="setTransfer"
            :disabled="!transfer.valid"
            >{{ t("transferir") }}</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <Classificar
      :open="modalClassificacao"
      :queueTypeID="1"
      :call="call"
      :atendimento="call.atendimento ? call.atendimento : null"
      :cancelar="false"
      v-on:updateClassificar:open="modalClassificacao = $event"
    />
    <Agendar
      :open="modalAgendar"
      :call="call"
      v-on:update="modalAgendar = $event"
    />
  </div>
</template>
   
<script>
import { mapState } from "vuex";
import { mapActions } from "vuex";
import Relogio from "./Relogio";

import moment from "moment-timezone";
import { debounce } from "../plugins/Debounce";
import Classificar from "./dialogs/Classificar";
import Agendar from "./dialogs/Agendamentos";
import Conferencia from "./atendimento/Conferencia.vue";
// import Recorder from "recorder-js";
// const audioContext = new (window.AudioContext || window.webkitAudioContext)();
// const recorder = new Recorder(audioContext);
// navigator.mediaDevices
//   .getUserMedia({ audio: true })
//   .then(stream => recorder.init(stream))
//   .catch(err => console.log("Uh oh... unable to get stream...", err));
export default {
  name: "Chat",
  components: {
    Relogio,
    Classificar,
    Agendar,
    Conferencia,
  },
  data() {
    return {
      expand: true,
      atendimento: null,
      poptransfer: false,
      transfer: { valid: false },
      page: 1,
      autoCompleteSearch: null,
      input: null,
      modalClassificacao: false,
      isRecording: false,
      blob: null,
      cliente: null,
      files: [],
      consultaNum: null,
      modalAgendar: false,
      legenda: null,
      modal: false,
      modalAnexo: false,
      modalTransfere: false,
      modalCliente: false,
      file: null,
      local: false,
      ENTER_KEY: 13,
      message: "",
      ip: "http://" + JSON.parse(localStorage.getItem("config")).servidor,
      config: JSON.parse(localStorage.getItem("config")),
      user: JSON.parse(localStorage.getItem("user")),
      classificacoes: [],
      classificacao: null,
      subclassificacoes: [],
      subclassificacao: null,
      obs: null,
      messages: [],
      windowHeight: 0,
      autoCompletes: [],
      urlIntegracao: null,
      keyBindings: [
        {
          key: 13,
          shiftKey: true,
          method: () => {
            this.send();
          },
        },
        {
          key: 220,
          method: () => {
            this.getAutoComplete();
          },
        },
      ],
    };
  },

  created() {
    try {
      let that = this;
      if (!this.call.conference) {
        let ramal = this.ramais.find((a) => a.name === this.call.numero);

        if (!ramal)
          this.newCall({
            fila: that.call.fila,
            origem: that.user.ramal,
            destino: that.call.numero,
            contexto: that.user.contexto,
            agente: that.user.fullname,
            action: "NewCall",
            sentido: that.call.sentido,
            uniqueid: that.call.uniqueid,
          });
        this.selectAtendimento(null);
      }

      // this.call.conference = {};
      // this.call.conference.users = [];
      // this.call.conference.users.push({ nome: `Roger Groff`, numero: `666` });
      // this.call.conference.users.push({ nome: `Juca Bala`, numero: `666` });
      // this.call.conference.users.push({ nome: `Max Samberg`, numero: `666` });
      // this.call.conference.users.push({
      //   nome: `Pedro Rogerio Groff`,
      //   numero: `666`,
      // });
      // this.call.conference.users.push({
      //   nome: `Fernando Rossato`,
      //   numero: `666`,
      // });
      // this.call.conference.users.push({ nome: `Macelo Kawano`, numero: `666` });
      // var container = this.$el.querySelector(".wa-chat");
      // container.scrollTop = container.scrollHeight;

      if (this.config.urlIntegracao && this.call.sentido === "Entrante") {
        let texto = this.config.urlIntegracao;
        console.log(`URL`, texto);
        Object.keys(this.call.dados).forEach((head) => {
          if (head.startsWith("X-")) {
            texto = texto.split(head).join(this.call.dados[head]);
          }
        });
        console.log(`URL`, texto);
        this.urlIntegracao = texto;
        let div = document.getElementById(`app`);
        let a = document.createElement(`a`);
        a.href = texto;
        a.target = `_blank`;
        a.style.display = `none`;
        a.id = "clienteUrl";
        div.appendChild(a);
        if (texto) {
          a.click();
          // document.getElementById("link").click();
        }
      }
    } catch (error) {
      console.error(error);
    }
  },

  computed: {
    ...mapState("sip", {
      registered: (state) => state.registered,
      calls: (state) => state.calls,
      isDiscando: (state) => state.isDiscando,
      isTocando: (state) => state.isTocando,
      isOcupado: (state) => state.isOcupado,
      call: (state) => state.newCall || state.newInvite,
    }),
    ...mapState(`xc`, {
      clientes: (state) => state.clientes,
      modalTransferencia: (state) => state.transferenciaModal,
      uploadStatus: (state) => state.uploadStatus,
      lastMsg: (state) => state.atendimento.lastMsg,
      atendimentosHistorico: (state) => state.atendimentosHistorico,
      ramais: (state) => state.ramais,
    }),
    ligacao() {
      let call = this.calls.find((c) => c.callid === this.call.callid);
      if (call) {
        return this.calls.find((c) => c.callid === this.call.callid);
      } else {
        return this.call;
      }
    },
  },
  watch: {
    ligacao(nw) {
      if (nw && nw.atendimento) {
        console.log(`EPA VEIO O ATENDIMENTO`);
        this.atendimento = nw.atendimento;
        this.getClienteByID();
        this.getMessages();
      }
    },
    call(nw) {
      if (nw && nw.atendimento) {
        this.atendimento = nw.atendimento;
        this.getClienteByID();
      }
    },

    modalTransferencia() {
      this.modalTransfere = !this.modalTransfere;
    },
    uploadStatus(nw) {
      if (nw === 100) {
        this.$bvModal.hide("anexar-modal");
      }
    },
    input: debounce(function (newVal) {
      this.autoCompleteSearch = newVal;
    }, 500),
  },
  methods: {
    async getMessages() {
      try {
        let retorno = await this.getDefault(
          `/api/v2/chat/${this.atendimento.id}/mensagens?max=-1&page=1`
        );
        this.messages = retorno.dados;
      } catch (error) {
        console.error(error);
      }
    },
    ...mapActions("sip", [
      "addLocalAudio",
      "atender",
      "desligar",
      "ligar",
      "ligarTransferencia",
      "Pausar",
      "Despausar",
      "MicOnOff",
      "Transferir",
      "remoteAudioId",
      "conference",
      "addUserConference",
    ]),
    ...mapActions("xc", [
      "getHistoricoAtendimentosAgente",
      "setCliente",
      "getDefault",
      "newCall",
      "selectAtendimento",
    ]),
    toggleMic(call) {
      call.mic = !call.mic;
      this.MicOnOff({ callid: call.callid, mic: call.mic });
    },
    async getClienteByID() {
      try {
        let retorno = await this.getDefault(
          `/api/v2/clientes/${this.atendimento.idCliente}`
        );
        //eslint-disable-next-line no-unused-vars
        /* eslint-disable  */
        let { idGrupo, profileImage, isBusiness, clienteGrupo, id, ...data } =
          retorno;
        /* eslint-enable */

        data = Object.entries(data).reduce(
          (a, [k, v]) => (v ? ((a[k] = v), a) : a),
          {}
        );
        if (data.CamposAdicionais && data.CamposAdicionais.length == 0)
          delete data.CamposAdicionais;
        if (data.NumerosAdicionais && data.NumerosAdicionais.length == 0)
          delete data.NumerosAdicionais;
        this.cliente = data;
      } catch (error) {
        console.error(error);
      }
    },
    confirmTransfer(callid) {
      this.transfer = {};
      this.transfer.valid = false;
      this.transfer.callid = callid;
      this.poptransfer = true;
    },
    removerPausaAutomatico() {
      if (this.calls.length == 1) {
        this.Despausar(this.calls[0].callid);
      }
    },
    setTransfer() {
      this.Transferir(this.transfer);
      this.poptransfer = false;
    },
    togglePause(call) {
      call.pause = !call.pause;
      if (call.pause) {
        this.Pausar(call.callid);
      } else {
        this.Despausar(call.callid);
      }
    },
    AttendedTransfer(callid) {
      this.transfer.callidDestino = callid;
      this.Transferir(this.transfer);
      this.poptransfer = false;
    },
    filterCalls: function (callid) {
      return this.calls.filter((call) => call.callid !== callid);
    },
    getCall() {
      return this.calls.find((c) => c.numero === this.atendimento.fromID);
    },
    desligarXc() {
      if (this.config.webrtc) {
        this.desligar(this.call.callid);
        return;
      }
      let dados = {
        ramal: this.user.ramal,
        destino: this.atendimento.fromID,
        contexto: this.user.contexto,
      };
      this.hangup(dados);
    },
    getStatus(status) {
      if (status === "Entrou") return this.t(`emAtendimento`);
      if (status === "Encerrado") return this.t(`finalizado`);
      return status;
    },
    ...mapActions(`xc`, ["sendMessage", "getDefault", "hangup"]),

    formataHora(dataHora) {
      moment.locale("pt-br");
      if (moment(dataHora).format("L") === moment(new Date()).format("L")) {
        return moment(dataHora).format("LT");
      } else {
        return moment(dataHora).format("lll");
      }
    },
    formataData(dataHora) {
      moment.locale("pt-br");
      return moment(dataHora).format("L");
    },
    discar() {
      if (!this.consultaNum) return;
      this.ligarTransferencia(this.consultaNum);
    },
    getIconByStatus() {
      if (this.atendimento.status === "Entrou") {
        return "mdi-sticker-check";
      } else if (this.atendimento.status === "Encerrado") {
        return "mdi-sticker-remove";
      } else {
        return "mdi-sticker-alert";
      }
    },
    getColorByStatus() {
      if (this.atendimento.status === "Entrou") {
        return "success";
      } else if (this.atendimento.status === "Encerrado") {
        return "error";
      } else {
        return "#FBC02D";
      }
    },
    async criarConferencia() {
      let agente = JSON.parse(localStorage.getItem(`user`));
      let dados = {};
      let call = JSON.parse(JSON.stringify(this.call));

      // dados.nome = "Participante";
      // dados.numero = this.call.numero;
      // dados.sala = agente.ramal.split(`/`)[1];
      // dados.qtdParticipantes = 1;
      // dados.users = [];
      // dados.users.push({
      //   nome: call.nome ? call.nome : "Participante",
      //   numero: this.call.numero,
      // });
      // this.desligar(this.call.callid);
      dados.nome = agente.nome;
      dados.ramal = agente.ramal;
      dados.numero = agente.ramal.split(`/`)[1];
      dados.sala = agente.ramal.split(`/`)[1];
      dados.qtdParticipantes = 1;
      dados.users = [];
      dados.users.push({ nome: agente.nome, numero: dados.numero });
      let retorno = await this.addUserConference(dados);
      call.destino = `*70${dados.sala}`;
      this.Transferir(call);
    },
    mostrarDados() {
      let dadosAux = this.call.dados;
      if (dadosAux && this.config.headers && this.config.headers.length > 0) {
        for (let header of this.config.headers) {
          Object.keys(this.call.dados).forEach((head) => {
            if (header !== head) {
              delete dadosAux[head];
            }
          });
        }
      }
      let returnAux = {};
      for (let key in dadosAux) {
        let nome = key.split(`X-`);
        returnAux[`${nome[1]}`] = decodeURIComponent(dadosAux[key]);
      }
      // if (Object.keys(returnAux).length == 0) returnAux = null;
      return returnAux;
    },
  },
};
</script>

<style>
.hover {
  padding: 50px;
}
.hover:hover {
  text-align: left !important;
}
</style>